import { render, staticRenderFns } from "./VipCriteriaList.vue?vue&type=template&id=15bf78b6&lang=pug"
import script from "./VipCriteriaList.vue?vue&type=script&lang=js"
export * from "./VipCriteriaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports